import { ReactNode } from 'react';
import Header from './header/Header';
import Footer from './footer/Footer';
import { Box } from '@mui/material';
import theme from '../../shared/theme';

type Props = {
    children: ReactNode
    solidHeader?: boolean
}

const Page = ({ children, solidHeader = false }: Props) => {
    return (<>
        <Header />
        <Box sx={{marginTop: theme.spacing(4), minHeight: '100vh', width: '100%' }}>
            {children}
        </Box>
        <Footer />
    </>
    );
}

export default Page;